import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { UserModel } from "@services/user/model/user.model";
import { TokenModel } from "@services/account/model/account.model";
import { getLocalStorage } from "@utils/localstorage";
import { LoginEnum } from "@services/account/enum/login.enum";
import { SelectedMenuModel } from "@services/home/model/home.model";

export interface GlobalStateModel {
  siderCollapsed: boolean;
  loginUser: UserModel | null;
  token: TokenModel | null;
  selectedMenu?: SelectedMenuModel;
  isJobSubmited: boolean;
  loginDialogVisible: boolean;
}

const initialState: GlobalStateModel = {
  siderCollapsed: false,
  loginUser: null,
  token: getLocalStorage<TokenModel>(LoginEnum.Token),
  isJobSubmited: false,
  loginDialogVisible: false,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    toggleSideBar: (state) => {
      state.siderCollapsed = !state.siderCollapsed;
    },
    setUser: (state, action: PayloadAction<UserModel>) => {
      state.loginUser = action.payload;
    },
    deleteUser: (state) => {
      state.loginUser = null;
    },
    changeRedDot: (state, action: PayloadAction<number>) => {
      if (state.loginUser) {
        // state.loginUser.red_dot = action.payload;
      }
    },
    setToken: (state, action: PayloadAction<TokenModel>) => {
      state.token = action.payload;
    },
    removeToken: (state) => {
      state.token = null;
    },

    setSelectedMenu: (
      state,
      action: PayloadAction<SelectedMenuModel | undefined>
    ) => {
      state.selectedMenu = action.payload;
    },

    setIsJobSubmited: (state, action: PayloadAction<boolean>) => {
      state.isJobSubmited = action.payload;
    },
    setLoginDialogVisible: (state, action: PayloadAction<boolean>) => {
      state.loginDialogVisible = action.payload;
    },
  },

  extraReducers: (builder) => {},
});

export const {
  toggleSideBar,
  setUser,
  deleteUser,
  changeRedDot,
  setToken,
  removeToken,
  setSelectedMenu,
  setIsJobSubmited,
  setLoginDialogVisible,
} = globalSlice.actions;

export default globalSlice.reducer;
